var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Filter_1;
import { JSON, JsonDiscriminatorProperty, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { filterSchemaValidation } from '../validations.generated';
export var FilterType;
(function (FilterType) {
    FilterType["BOOLEAN"] = "boolean";
    FilterType["DATE"] = "date";
    FilterType["STRING"] = "string";
    FilterType["NUMBER"] = "number";
    FilterType["GROUP"] = "group";
    FilterType["DECIMAL"] = "decimal";
})(FilterType || (FilterType = {}));
// https://pandas.pydata.org/pandas-docs/stable/reference/api/pandas.Interval.html
// The closed interval [0, 5] is characterized by the conditions 0 <= x <= 5. This is what closed='both' stands for. An open interval (in mathematics denoted by parentheses) does not contain its endpoints,
// The open interval (0, 5) is characterized by the conditions 0 < x < 5. This is what closed='neither' stands for.
// Intervals can also be half-open or half-closed, i.e. [0, 5) is described by 0 <= x < 5 (closed='left') and (0, 5] is described by 0 < x <= 5 (closed='right').
export var Closed;
(function (Closed) {
    Closed["LEFT"] = "left";
    Closed["RIGHT"] = "right";
    Closed["BOTH"] = "both";
    Closed["NEITHER"] = "neither";
})(Closed || (Closed = {}));
export const filterSchema = {
    $id: 'urn:wisepipe-common-computation:Filter',
    type: 'object',
    properties: {
        column: { type: 'string', maxLength: 150 },
        filterType: { type: 'string', enum: Object.values(FilterType) }
    },
    required: ['filterType']
};
let Filter = Filter_1 = class Filter {
    constructor(column, filterType) {
        this.column = column;
        this.filterType = filterType;
        JSON.validate(this, Filter_1);
    }
};
Filter = Filter_1 = __decorate([
    JsonSchemaV2(filterSchema, filterSchemaValidation),
    JsonDiscriminatorProperty('filterType')
], Filter);
export { Filter };
//# sourceMappingURL=filter.js.map